import styled from "styled-components";

const StyledFormInput = styled.div`
	width: 100%;
	display: flex;
	align-items: center;

	.sb-form-input {
	}

	input {
		background: ${({ theme }) => theme.colors.white};
		border: 1px solid ${({ theme }) => theme.colors.iron};
		border-radius: 100px;
		height: 48px;
		padding: 16px;
	}

	.input-dark {
		background: ${({ theme }) => theme.colors.shark};
		border: 1px solid ${({ theme }) => theme.colors.shark};
		color: ${({ theme }) => theme.colors.white};
		border-radius: 100px;
		height: 46px;
		padding: 16px;

		.ant-form-item-explain-error {
			width: fit-content;
			height: 24px;
			line-height: 24px;
			border-radius: 100px;
			font-family: "DM Sans", sans-serif;
			font-style: normal;
			font-weight: 500;
			font-size: 14px;
			line-height: 17px;
			color: ${({ theme }) => theme.colors.shark};
		}
	}

	.ant-form-item {
		width: 100%;
	}

	.ant-form-item-explain-error {
		width: fit-content;
		height: 24px;
		line-height: 24px;
		border-radius: 100px;
		font-family: "DM Sans", sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: 14px;
		color: ${({ theme }) => theme.colors.burntSienna};
	}

	.ant-input-affix-wrapper {
		border-radius: 100px;
		padding: 0 12px;
	}
`;

export default StyledFormInput;

